const Camelize = (str: string) => str.replace(/-./g, l => l[1].toUpperCase())

export default Camelize
